import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import WavesTop from "../components/WavesTop";
import WavesBottom from "../components/WavesBottom";
import CallToAction from "../components/CallToAction";
import { PageRendererProps, StaticQuery, graphql } from "gatsby";
import PartnerFeatures from "../components/PartnerFeatures";
import PosCards from "../components/PosCards";
import OrderTypeDescription from "../components/OrderTypeDescription";
import Modal from "../components/Modal";
import PricingCards from "../components/PricingCards";
import Gastronomies from "../components/Gastronomies";
// import Config from "./../config";
// import MessengerCustomerChat from "react-messenger-customer-chat";

const query = graphql`
  query PartnerQuery {
    site {
      siteMetadata {
        gastroClient
      }
    }
  }
`;

const PartnerPage = ({ location }: PageRendererProps) => {
  return (
    <StaticQuery
      query={query}
      render={(_data) => (
        <Layout location={location}>
          <Seo
            title="Partner"
            description="So muss Gastro-Zukunft - Der neue Standard in der Gastronomie!"
            keywords={[
              `getsby`,
              `Bestellen`,
              `Bezahlen`,
              `Take-Away`,
              `Lieferung`,
              `Kontaktlos`,
            ]}
          />

          <Modal
            title="Vorteile in Corona-Zeiten"
            subTitle="Gleicher Service bei geringerem Risiko!"
            body={
              <React.Fragment>
                <p className="text-gray-800 my-6">
                  Mit getsby funktioniert das Bestellen und Bezahlen über das
                  Smartphone, also ohne direkten persönlichen Kontakt mit Ihren
                  Service-Mitarbeitern. Damit wird eine mögliche
                  Ansteckungsgefahr minimiert.
                </p>
                <p className="text-gray-800 my-6">
                  Weiters ist es möglich, einfach einen eigenen{" "}
                  <b>Lieferbetrieb</b> einzurichten. Dazu benötigen Sie nur ein
                  handelsübliches Android Smartphone oder Tablet.
                </p>
              </React.Fragment>
            }
            id="modal-partner-corona"
          />

          <Hero
            keywords="So muss Gastro-Zukunft"
            title="Der neue Standard in der Gastronomie!"
            subTitle="Mit getsby bestellen & bezahlen Ihre Gäste einfach selbst über ihr Smartphone!"
            imgSrc={require("../images/phone-partner-landscape.png")}
            deviceType="frame"
            callToAction={
              <a
                className="mx-auto lg:mx-0 font-bold rounded-full mt-4 lg:mt-0 py-4 px-8 shadow-lg bg-gray-800 text-white"
                href="https://docs.google.com/forms/d/e/1FAIpQLSc1Ex0h6Urdiar-NAKdI01ZYSuJ1o5hz8veZW2o7r-UYgtnhQ/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Infos anfordern
              </a>
            }
          />

          <WavesTop />

          <Gastronomies
            description={
              <h3 className="text-3xl text-center text-gray-800 font-bold leading-none mt-16 mx-6">
                ... die bereits von getsby profitieren!
              </h3>
            }
          />

          <PartnerFeatures />

          <OrderTypeDescription />

          <PricingCards />

          <PosCards />

          <WavesBottom fillColor="#f8fafc" />

          <CallToAction
            title="Heben Sie Ihren Service auf das nächste Level!"
            subTitle="Der beste Service für Ihre Gäste - selbst bei großem Andrang!"
            callToAction={
              <a
                className="mx-auto lg:mx-0 font-bold rounded-full py-4 px-8 shadow-lg bg-gray-800 text-white"
                href="https://docs.google.com/forms/d/e/1FAIpQLSc1Ex0h6Urdiar-NAKdI01ZYSuJ1o5hz8veZW2o7r-UYgtnhQ/viewform"
                target="_blank"
                rel="noopener noreferrer"
              >
                Service anheben!
              </a>
            }
          />

          {/* 
          <MessengerCustomerChat
            pageId={Config.facebookPageId}
            appId={Config.facebookAppId}
            themeColor={"#f0c314"}
            language="de_DE"
            loggedInGreeting="Hi! Wie können wir Ihnen helfen?"
            loggedOutGreeting="Hi! Wie können wir Ihnen helfen?"
          />
          */}
        </Layout>
      )}
    />
  );
};

export default PartnerPage;
